/**
 * Moves the pool screen to another tab from inside a Squares pane, the same
 * way the pool screen's own tab bar does: `?tab=` on `/pools`, replacing the
 * history entry so Back still leaves the pool.
 */
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import {
  openPoolTabSearch,
  type typePoolTab,
} from "../poolScreen/poolScreenRoute";

export function useSquaresOpenPoolTab(): (tab: typePoolTab) => void {
  const navigate = useNavigate();
  return useCallback(
    (tab: typePoolTab) => {
      void navigate({
        to: "/pools",
        search: (prev: Record<string, unknown>) =>
          openPoolTabSearch(prev, tab) as never,
        replace: true,
      });
    },
    [navigate],
  );
}
